import { getDomain } from 'www/utils/get-domain';
class ShareWidgetApi{
	shareEmail(){
		if (typeof sendMsgInit == 'undefined') {
			let sendMsgJs = document.createElement('script');
			sendMsgJs.onload = function() {		
					sendMsgInit({
						pubName: emailThis.publicationName,
						pubDate: emailThis.publicationDate
					});
			};
			document.body.appendChild(sendMsgJs);
			sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
		} else {
			sendMsgInit();
		}
	}
	shareFacebook(){
		window.fburl();
	}
	shareLinkedin(){
		window.linkedinurl();
	}
	shareTwitter(){
		window.twiturl();
	}
}

export {ShareWidgetApi}